<template>
  <tippy
    :append-to="getAppendToElement"
    :interactive="true"
    :trigger="'manual'"
    ref="rootTippy"
    @clickOutside="hideTippyGuide()"
  >
    <slot/>
    <template #content>
      <div class="w-48 flex flex-col">
        <span class="text-base text-center p-4 pb-6">
          {{ $t(contentMessage) }}
        </span>
        <div class="flex flex-row justify-between items-center pb-2">
          <button
            v-if="itemIndex === 0"
            @click.stop.prevent="hideTippyGuide"
            class="w-1/2 inline-flex flex-row items-center justify-start mr-2"
          >
            <aw-icon
              icon="close"
              class="w-5 h-5"
            />
            {{ $t('Close') }}
          </button>
          <button
            v-else
            @click.stop.prevent="showPreviousTippy"
            class="w-1/2 inline-flex flex-row items-center justify-start mr-2"
          >
            <aw-icon
              icon="chevron-left"
              class="w-5 h-5"
            />
            {{ $t('Previous') }}
          </button>
          <button
            v-if="itemIndex === lastItemIndex"
            @click.stop.prevent="hideTippyGuide"
            class="w-1/2 inline-flex flex-row items-center justify-end ml-2"
          >
            <aw-icon
              icon="close"
              class="w-5 h-5"
            />
            {{ $t('Close') }}
          </button>
          <button
            v-else
            @click.stop.prevent="showNextTippy"
            class="w-1/2 inline-flex flex-row items-center justify-end ml-2"
          >
            {{ $t('Next') }}
            <aw-icon
              icon="chevron-right"
              class="w-5 h-5"
            />
          </button>
        </div>
      </div>
    </template>
  </tippy>
</template>

<script>
import useTippyGuideStore from '@/frontapp/store/tippyGuide'
import { mapStores } from 'pinia'

export default {
  props: {
    contentMessage: {
      type: String,
      required: true
    },
    itemIndex: {
      type: Number,
      required: true
    },
    groupId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      lastItemIndex: 1
    }
  },
  methods: {
    addKeyHandler() {
      window.addEventListener('keydown', this.keyHandler)
    },
    keyHandler(event) {
      if (event.keyCode === 27 || event.key === 'Escape' || event.code === 'Escape') {
        this.hideTippyGuide()
      } else if (event.keyCode === 37 || event.key === 'ArrowLeft' || event.code === 'ArrowLeft') {
        this.showPreviousTippy()
      } else if (event.keyCode === 32 || event.key === ' ' || event.code === 'Space' || event.keyCode === 39 || event.key === 'ArrowRight' || event.code === 'ArrowRight') {
        this.showNextTippy()
      }
    },
    hideCurrentTippy() {
      this.$refs.rootTippy.tippy.hide()
      this.removeKeyHandler()
    },
    hideTippyGuide() {
      this.tippyGuideStore.resetCurrentTippyGroup()
      this.hideCurrentTippy()
    },
    removeKeyHandler() {
      window.removeEventListener('keydown', this.keyHandler)
    },
    showNextTippy() {
      if (this.tippyGuideStore.currentTippyGroup.currentItem < this.lastItemIndex) {
        let nextBiggest = Number.POSITIVE_INFINITY
        for (const num of this.tippyGuideStore.currentTippyGroup.items) {
          if (num > this.itemIndex && num < nextBiggest) {
            nextBiggest = num
          }
        }
        this.tippyGuideStore.currentTippyGroup.currentItem = nextBiggest
        this.hideCurrentTippy()
      } else {
        this.hideTippyGuide()
      }
    },
    showPreviousTippy() {
      if (this.tippyGuideStore.currentTippyGroup.currentItem > 0) {
        let nextSmallest = 0
        for (const num of this.tippyGuideStore.currentTippyGroup.items) {
          if (num < this.itemIndex && num > nextSmallest) {
            nextSmallest = num
          }
        }
        this.tippyGuideStore.currentTippyGroup.currentItem = nextSmallest
        this.hideCurrentTippy()
      } else {
        this.hideTippyGuide()
      }
    },
    getAppendToElement() {
      return document.querySelector('.BcLayout__Content')
    }
  },
  computed: {
    ...mapStores( useTippyGuideStore ),
  },
  watch: {
    'tippyGuideStore.currentTippyGroup': {
      deep: true,
      handler(newVal) {
        if(!newVal) return
        let maxValue = 1
        for (const num of newVal.items) {
          if (num > maxValue) maxValue = num
        }
        this.lastItemIndex = maxValue
        if (newVal.currentItem === this.itemIndex && newVal.id === this.groupId) {
          this.addKeyHandler()
          this.$refs.rootTippy.tippy.show()
        }
      }
    },
  },
  mounted () {
    this.tippyGuideStore.addTippyGroup(this.groupId, this.itemIndex)
  },
  unmounted () {
    this.tippyGuideStore.removeTippyGroup(this.groupId)
  }
}
</script>

<style lang="scss">
.TippyGuide__Btn {
  margin-top: -0.25rem !important;

  @screen lg {
    margin-top: 0 !important;
  }
}
</style>
